import { CircularProgress, Tooltip } from "@mui/material";
import { Check as CheckIcon, Error as ErrorIcon, AutoMode as AutoModeIcon } from "@mui/icons-material";

const ItemStatusIndicator = ({ isMutating, success, error }) => {
  return isMutating ? (
    <CircularProgress size={24} />
  ) : success ? (
    <Tooltip title="Changes successfully saved">
      <CheckIcon sx={{ color: "#4caf50", fontSize: 24 }} />
    </Tooltip>
  ) : error ? (
    <Tooltip title="Could not sync with backend">
      <ErrorIcon sx={{ color: "#e61e1e", fontSize: 24 }} />
    </Tooltip>
  ) : (
    <Tooltip title="No changes detected">
      <AutoModeIcon sx={{ color: "#4caf50", fontSize: 24 }} />
    </Tooltip>
  );
};

export default ItemStatusIndicator;
